import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";

export const getTemplate = (state: ReducerFromState<MonitorReducer>): null | string => state.monitor.template;
